import React from 'react'
import Page from '../components/Page'
import { Button, Card, CardBody, CardHeader, Col, Label, Row, Table, Modal, ModalBody, ModalFooter, ModalHeader, Nav, NavItem, NavLink, TabContent, TabPane, Form, FormFeedback, FormGroup, FormText, Input } from 'reactstrap'
import axios from '../utils/posAxios'
import StorageService from '../services/StorageService'
import { MdCameraAlt, MdFace, MdDone, MdClear, MdCreate, MdAdd, MdTransferWithinAStation } from 'react-icons/md'
import { BsPlusSquareFill } from 'react-icons/bs'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import { Redirect } from 'react-router'
import classnames from 'classnames'
import PosShippingForm from '../components/PosShippingForm'
import { IconContext } from 'react-icons/lib'
import PosPromoTable from './PosPromoTable'

class PosMembershipForm extends React.Component {
  _isMounted = true
  constructor(props) {
    super(props)
    this.state = {
      isEdit: false,
      isGlobal: true,
      id: '',
      name: '',
      member_type: '',
      accumulation: '',
      start_date: '',
      end_date: '',
      membershipList: [],
    }
  }

  componentDidMount() {
    this.Membership()
    if (this.props.data.isGlobal) {
      if (this.props.data.isEdit) {
        let id = this.props.data.selectedId
        const data = this.props.data.membershipList.find(e => e.id === id)
        this.setState({
          id: id,
          name: data.name,
          member_type: data.member_type,
          accumulation: data.accumulation,
          start_date: data.start_date,
          end_date: data.end_date,
          isEdit: true,
          isGlobal: this.props.data.isGlobal,
        })
      }
    } else {
      //no global for membership
      this.setState({
        store_id: this.props.data.store_id,
        isGlobal: this.props.data.isGlobal,
      })
    }
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  changeHandler = e => {
    let { name, value } = e.target

    this.setState({
      [name]: value,
    })
  }

  handleSubmit = event => {
    event.preventDefault()
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL

    if (this.state.isGlobal) {
      if (!this.state.isEdit) {
        this.create(user, comp, url)
      } else {
        this.update(user, comp, url)
      }
    } else {
      //no global for membership
      this.add(user, comp, url)
    }
  }

  Membership = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    }

    axios
      .post(url + ':3001/v1/membership', data)
      .then(response => {
        const result = response.data
        const storeMembership = this.props.data.membershipList

        let MembershipOp = result.data.filter(x => !storeMembership.some(y => y.id === x.id))

        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }

        if (this._isMounted) {
          this.setState({
            membershipList: MembershipOp,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  create(user, comp, url) {
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
      name: this.state.name,
      member_type: this.state.member_type,
      accumulation: this.state.accumulation,
      start_date: this.state.start_date,
      end_date: this.state.end_date,
      created_by: user.email,
    }

    axios
      .post(url + ':3001/v1/membership/create', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false)
          return
        }

        this.props.closeModal(<MdDone />, 'New membership added successfully.', 'success', false)
      })
      .catch(error => {
        alert(error)
      })
  }

  update(user, comp, url) {
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      id: this.state.id,
      name: this.state.name,
      member_type: this.state.member_type,
      accumulation: this.state.accumulation,
      start_date: this.state.start_date,
      end_date: this.state.end_date,
      update_by: user.email,
    }

    axios
      .post(url + ':3001/v1/membership/update', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false)
          return
        }

        this.props.closeModal(
          <MdDone />,
          'Membership details updated successfully.',
          'success', //'error' post when return error
          false,
        )
      })
      .catch(error => {
        alert(error)
      })
  }

  //   add(user, comp, url) {
  //     const data = {
  //       session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
  //       store_id: this.state.store_id,
  //       promo_id: this.state.promo_id,
  //       added_by: user.email,
  //     }

  //     axios
  //       .post(url + ':3001/v1/store/promo/add', data)
  //       .then(response => {
  //         const result = response.data
  //         if (result.error == true) {
  //           this.props.closeModal(<MdClear />, result.message, 'error', false)
  //           return
  //         }

  //         this.props.closeModal(<MdDone />, 'New Promo added successfully.', 'success', false)
  //       })
  //       .catch(error => {
  //         alert(error)
  //       })
  //   }

  render() {
    return (
      <Form className="AuthForm" onSubmit={this.handleSubmit}>
        <ModalHeader toggle={this.props.onToggleModal()}>Membership {this.state.isGlobal ? 'Details' : 'List'}</ModalHeader>
        <ModalBody>
          {this.state.isGlobal ? (
            <Row>
              <Col md={12}>
                <FormGroup>
                  <Label>Name</Label>
                  <Input type="text" name="name" value={this.state.name} onChange={this.changeHandler} required />
                </FormGroup>
                <FormGroup>
                  <Label>Member Type</Label>
                  <Input type="select" name="member_type" value={this.state.member_type} onChange={this.changeHandler} required>
                    <option value=""></option>
                    <option value="Monthly">Monthly</option>
                    <option value="Yearly">Yearly</option>
                  </Input>
                </FormGroup>
                <FormGroup>
                  <Label>Accumulation</Label>
                  <Input type="select" name="accumulation" value={this.state.accumulation} onChange={this.changeHandler} required>
                    <option value=""></option>
                    <option value="Purchase">Purchase</option>
                    <option value="Order">Order</option>
                  </Input>
                </FormGroup>

                <FormGroup>
                  <Label>Start Date</Label>
                  <Input type="date" name="start_date" value={this.state.start_date} onChange={this.changeHandler} required />
                </FormGroup>
                <FormGroup>
                  <Label>End Date</Label>
                  <Input type="date" name="end_date" value={this.state.end_date} onChange={this.changeHandler} required />
                </FormGroup>
              </Col>
            </Row>
          ) : (
            <Row>
              <Col md={12}>
                <FormGroup>
                  <Label></Label>
                  <Input type="select" name="promo_id" onChange={this.changeHandler} required>
                    <option></option>
                    {this.state.promoList &&
                      this.state.promoList.map(item => {
                        return (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        )
                      })}
                  </Input>
                </FormGroup>
              </Col>
            </Row>
          )}
        </ModalBody>
        <ModalFooter>
          <Button className="theme-button theme-button-secondary" onClick={this.props.onToggleModal()}>
            Close
          </Button>
          <Button className="theme-button theme-button-primary" type="submit">
            Save
          </Button>
        </ModalFooter>
      </Form>
    )
  }
}

export default PosMembershipForm
